<template>
  <div class="loging_contain">
    <div class="container d-flex justify-content-center align-items-center vh-100">
      <div class="card shadow-lg p-4" style="max-width: 400px; width: 100%;">

        <div style="display: flex; justify-content: flex-end;">
          <a href="/" class="btn"
            style="padding: 0.25rem 0.5rem; width: auto; display: inline-flex; align-items: center;">
            <i class="material-icons" style="font-size:20px; color:#143D60;">close</i>
          </a>
        </div>
        <h1>Connexion</h1>

        <form @submit.prevent="login">
          <div class="mb-3">
            <div class="form-group">
              <label for="user_mail" class="form-label">Email</label>
              <input type="text" class="form-control" id="user_mail" v-model="user.mail" autocomplete="email"
                placeholder="exemple@domaine.com" required />
            </div>
          </div>
          <div class="mb-3 position-relative">
            <div class="form-group">
              <label for="user_password" class="form-label">Mot de passe</label>
              <input :type="showPassword ? 'text' : 'password'" class="form-control" id="user_password"
                v-model="user.password" autocomplete="current-password" placeholder="Entrez votre mot de passe"
                required />
              <button type="button" class="btn btn-sm  position-absolute top-50 end-0  me-2"
                @click="showPassword = !showPassword">
                <i class="material-icons" style="font-size:20px;color:grey;">{{ showPassword ? 'visibility_off' :
                  'visibility' }}
                </i>
              </button>
            </div>
          </div>
          <br />
          <div class="form-group">
            <button type="submit" class="btn btn-primary">Connexion</button>

          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { accountService } from '../../services/account.service';


export default {
  name: 'LoginPage',
  data() {
    return {
      user: {
        mail: '',
        password: ''
      },
      showPassword: false,
    }
  },
  methods: {
    async login() {
      try {
        await accountService.login({
          mail: this.user.mail,
          password: this.user.password
        });

        const redirect = this.$route.query.redirect || '/admin/dashboard';
        this.$router.push(redirect);
      } catch (err) {
        console.error('Échec de la connexion', err);
        this.errorMessage = "Identifiants invalides";
      }
    }
  }
}
</script>

<style>
.loging_contain {
  width: 100vw;
  height: 100vh;
  background-image: url('@/assets/pile-wood-logs.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>